import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "td-container"
  }, [_c("TitleBar"), _vm._m(0), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "login-box"
  }, [_c("h4", [_vm._v(_vm._s(_vm.$t("TestDrive")))]), _c("div", {
    staticClass: "password1"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("name")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Name"
    },
    domProps: {
      value: _vm.password
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "account"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Mobile Phone")]), _c("div", {
    staticClass: "bottom"
  }, [_c("span", {
    on: {
      click: _vm.getCountry
    }
  }, [_vm._v(_vm._s(_vm.countryCode) + " "), _c("span", [_vm._v("▼")])]), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userName,
      expression: "userName"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Phone/Email"
    },
    domProps: {
      value: _vm.userName
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.userName = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".account .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".account .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "verificationCode"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Verification Code")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verificationCode,
      expression: "verificationCode"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Verification Code"
    },
    domProps: {
      value: _vm.verificationCode
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verificationCode = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".verificationCode .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".verificationCode .bottom");
      }
    }
  }), _c("span", {
    staticClass: "send-btn",
    on: {
      click: _vm.send
    }
  }, [_vm._v("Send")])])]), _c("div", {
    staticClass: "password2"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Models")]), _c("div", {
    staticClass: "bottom"
  }, [_vm.verifyType === "checkbox" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Models",
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(_vm.verifyPassword) ? _vm._i(_vm.verifyPassword, null) > -1 : _vm.verifyPassword
    },
    on: {
      input: _vm.models,
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      },
      change: function change($event) {
        var $$a = _vm.verifyPassword,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.verifyPassword = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.verifyPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.verifyPassword = $$c;
        }
      }
    }
  }) : _vm.verifyType === "radio" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Models",
      type: "radio"
    },
    domProps: {
      checked: _vm._q(_vm.verifyPassword, null)
    },
    on: {
      input: _vm.models,
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      },
      change: function change($event) {
        _vm.verifyPassword = null;
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Models",
      type: _vm.verifyType
    },
    domProps: {
      value: _vm.verifyPassword
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verifyPassword = $event.target.value;
      }, _vm.models],
      focus: function focus($event) {
        return _vm.focus(".password2 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password2 .bottom");
      }
    }
  }), _c("div", {
    on: {
      click: function click($event) {
        return _vm.showVerifyWord(_vm.verifyType);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Search-more.png"),
      alt: ""
    }
  })])])]), _c("div", {
    staticClass: "password3"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Address")]), _c("div", {
    staticClass: "bottom"
  }, [_vm.verifyType === "checkbox" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Address",
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(_vm.verifyPassword) ? _vm._i(_vm.verifyPassword, null) > -1 : _vm.verifyPassword
    },
    on: {
      input: _vm.address,
      focus: function focus($event) {
        return _vm.focus(".password3 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password3 .bottom");
      },
      change: function change($event) {
        var $$a = _vm.verifyPassword,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.verifyPassword = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.verifyPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.verifyPassword = $$c;
        }
      }
    }
  }) : _vm.verifyType === "radio" ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Address",
      type: "radio"
    },
    domProps: {
      checked: _vm._q(_vm.verifyPassword, null)
    },
    on: {
      input: _vm.address,
      focus: function focus($event) {
        return _vm.focus(".password3 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password3 .bottom");
      },
      change: function change($event) {
        _vm.verifyPassword = null;
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyPassword,
      expression: "verifyPassword"
    }],
    attrs: {
      placeholder: "Enter Address",
      type: _vm.verifyType
    },
    domProps: {
      value: _vm.verifyPassword
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verifyPassword = $event.target.value;
      }, _vm.address],
      focus: function focus($event) {
        return _vm.focus(".password3 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password3 .bottom");
      }
    }
  }), _c("div", {
    on: {
      click: function click($event) {
        return _vm.showVerifyWord(_vm.verifyType);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Search-more.png"),
      alt: ""
    }
  })])])])]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.toLogin
    }
  }, [_vm._v("submit")])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "img-con-top"
  }, [_c("img", {
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/sns_bg.png",
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };